import { defaultHelpMeNowQuestion, defaultProactiveSuggestionInterval, type TimelineFeatures } from "@expert/features";

export const features: TimelineFeatures = {
    helpMeNowQuestion: defaultHelpMeNowQuestion,
    isAutoCompleteEnabled: false,
    isGuidedFlowRecommendationEnabled: false,
    isHelpMeNowEnabled: true,
    isOutageAlertInfoEnabled: false,
    isProactiveEnabled: false,
    isProactiveSuggestionEnabled: false,
    isReactiveCallContextEnabled: false,
    isReactiveCallContextV2Enabled: false,
    isSalesFAQEnabled: false,
    proactiveSuggestionInterval: defaultProactiveSuggestionInterval,
};
